import React from "react";
import { SearchWidgetConfig } from "../config";

const defaultValue: SearchWidgetConfig = {
    api: {
        key: "",
        url: ""
    },
    suggestionsUrl: "",
    isVoiceEnabled: false
};

export const SearchWidgetConfigContext = React.createContext<SearchWidgetConfig>(defaultValue);